import React, { useState } from "react";
import { Col, Row, Form, Button, Card, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../academyStore/slices/AuthSlice";
import JobImage from "../assets/job.png";

const Signup = () => {
  let navigate = useNavigate();
  const [userReg, setUserReg] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    degree: "",
    year: "",
    college: "",
    branch: "",
    gender: "",
    referral: "",
  });
  const msg = useSelector((state) => state.user.message);
  const dispatch = useDispatch();
  const registerHandler = (e) => {
    e.preventDefault();
    dispatch(registerUser(userReg))
      .unwrap()
      .then(() =>
        setTimeout(() => {
          navigate("/login");
          window.location.reload();
        }, 5000)
      );
  };
  return (
    <section className="login position-relative">
      <Row className="mx-0 px-5">
        <Col
          md={8}
          className="position-absolute top-50 start-50 translate-middle h-100 my-3"
        >
          <Row className="">
            {/* <Col
              md={5}
              className="px-0 bg-white shadow-lg pt-5 rounded-start mx-auto"
            >
              <h1 className="text-center">
                <i className="fas fa-user-check border text-success rounded-circle px-4 py-4"></i>
              </h1>
              <h5 className="text-center pb-3">On Sign Up, you can</h5>
              <ul>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Build your profile and let recruiters find you
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Find a job and grow your career
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Take MCQ tests and let improve your skills
                </li>
                <li>
                  <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                  &nbsp; Get job alerts to your email
                </li>
              </ul>
              <p className="text-center">
                Already Sign Up?{" "}
                <span
                  className="fw-bolder sign"
                  onClick={() => navigate("/login")}
                >
                  Sign In
                </span>{" "}
                here
              </p>
              <p className="pt-4 pb-0">
                <img src={JobImage} alt="Job Image" className="img-fluid" />
              </p>
            </Col> */}
            <Col md={7} className=" shadow-lg bg-white rounded-end  mx-auto">
              <h3 className="px-3 pt-4 pb-3 text-center">
                Signup & grow your career
              </h3>
              <h6 className="text-success">{msg}</h6>
              <Form className="p-3" onSubmit={registerHandler}>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="username">Full Name</Form.Label>
                      <Form.Control
                        placeholder="Enter your full name"
                        id="name"
                        name="name"
                        value={userReg.name}
                        onChange={(e) => {
                          setUserReg({ ...userReg, name: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="email">Email Id</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email id"
                        id="email"
                        name="email"
                        value={userReg.email}
                        onChange={(e) => {
                          setUserReg({ ...userReg, email: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="phone">Mobile no</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="Enter your mobile number"
                        id="phone"
                        phone="phone"
                        value={userReg.phone}
                        onChange={(e) => {
                          setUserReg({ ...userReg, phone: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="password">Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Enter password"
                        id="password"
                        name="password"
                        value={userReg.password}
                        onChange={(e) => {
                          setUserReg({ ...userReg, password: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="qualification">
                        Degree{" "}
                        <span className="text-secondary">(Ex.BTech)</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your qualification"
                        id="qualification"
                        name="qualification"
                        value={userReg.degree}
                        onChange={(e) => {
                          setUserReg({ ...userReg, degree: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="year">Year of Graduation</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter year of graduation"
                        id="year"
                        name="year"
                        value={userReg.year}
                        onChange={(e) => {
                          setUserReg({ ...userReg, year: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="college">College Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your college"
                        id="college"
                        name="college"
                        value={userReg.college}
                        onChange={(e) => {
                          setUserReg({ ...userReg, college: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="year">
                        Graduation stream{" "}
                        <span className="text-secondary">(Ex.CSE,ECE..)</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your graduation stream"
                        id="branch"
                        name="branch"
                        value={userReg.branch}
                        onChange={(e) => {
                          setUserReg({ ...userReg, branch: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="gender">Gender</Form.Label>
                      <Form.Select
                        id="gender"
                        name="gender"
                        value={userReg.gender}
                        onChange={(e) => {
                          setUserReg({ ...userReg, gender: e.target.value });
                        }}
                      >
                        <option value="">Select Gender</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="year">Referral by</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter referral by name"
                        id="referral"
                        name="referral"
                        value={userReg.referral}
                        onChange={(e) => {
                          setUserReg({ ...userReg, referral: e.target.value });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group className="mb-1">
                      <Form.Check
                        type="checkbox"
                        id="whatsapp"
                        inline
                        checked
                      />
                      <Form.Label htmlFor="whatsapp">
                        Send me important updates on{" "}
                        <span>
                          <i className="fab fa-whatsapp text-success"></i>
                        </span>{" "}
                        WhatsApp
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row> */}
                <Row className="pb-1">
                  <Col>
                    <small className="terms">
                      By clicking Register, you agree to the{" "}
                      <span className="text-primary">Terms and Conditions</span>
                      &nbsp; of HT Academy.
                    </small>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Button variant="danger" className="w-100" type="submit">
                    Sign Up Now
                  </Button>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default Signup;
